import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CostCenter } from '../costcenter/costcenter';
import { Observable } from 'rxjs';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class CostcenterService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<CostCenter[]> {
    return this.httpClient.get<CostCenter[]>(this.baseUrl + 'api/CostCenterApi')
  }
  Post(costcenter: CostCenter): Observable<any> {

  
    return this.httpClient.post(this.baseUrl + 'api/CostCenterApi/Add', costcenter, { headers: header, observe: 'response' })
  }
  Delete(costcenter: CostCenter) {
  
    return this.httpClient.post(this.baseUrl + 'api/CostCenterApi/activeordeactive', costcenter, { headers: header, observe: 'response' })
  }
  Put(costcenter: CostCenter): Observable<any> {
  
    return this.httpClient.put(this.baseUrl + 'api/CostCenterApi/Update', costcenter, { headers: header, observe: 'response' })
  }
}
